import _ from 'lodash';
import { Model } from 'backbone';

export default class FavouritesModel extends Model {
	initialize() {
		this.prefix = 'players/';

		this.setFavouritesUrl();
	}

	defaults() {
		return {
			list: []
		}
	}

	parse({ result }) {
		return {
			list: (_.isArray(result) ? result : _.clone(this.get('list'))).map(Number)
		}
	}

	setFavouritesUrl() {
		this.url = 'favourites';
	}

	setAddFavouritesUrl() {
		this.url = 'add_to_favourites';
	}

	setRemoveFavouritesUrl() {
		this.url = 'remove_from_favourites';
	}

	isFavourite(id) {
		id = parseInt(id, 10);

		return this.get('list').includes(id);
	}

	toggle(player_id) {
		let list = this.get('list').slice();

		if (this.isFavourite(player_id)) {
			this.setRemoveFavouritesUrl();

			list = list.filter(id => id !== player_id);
		}
		else {
			this.setAddFavouritesUrl();

			list.push(player_id);
		}

		this.set({ list });

		return this.getData({
			type: 'toggle',
			data: { player_id },
		});
	}
}